import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { FaceLivenessDetector } from "@aws-amplify/ui-react-liveness";
import {
  Loader,
  ThemeProvider,
  ToggleButton,
  ToggleButtonGroup,
} from "@aws-amplify/ui-react";
import {
  RekognitionClient,
  GetFaceLivenessSessionResultsCommand,
  DetectFacesCommand,
} from "@aws-sdk/client-rekognition";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import {
  verifyProcess,
  trackPageVisiting,
} from "../../services/faceLiveness";
import {
  S3Client,
  GetObjectCommand,
  DeleteObjectCommand,
} from "@aws-sdk/client-s3";
import { Typography } from "@mui/material";
import { images } from "../../assets";
import "./index.css";
import { decrypt } from "../../utils/functions";
import { guestCredentialProvider } from "./guestCredentials";


// const REGION = decrypt(process.env.REACT_APP_AWS_PROJECT_REGION);
// const IDENTITY_POOL_ID = decrypt(process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID);
// const s3 = new S3Client({
//   region: decrypt(process.env.REACT_APP_AWS_PROJECT_REGION),
//   credentials: {
//     accessKeyId: decrypt(process.env.REACT_APP_AWS_ACCESS_KEY_ID),
//     secretAccessKey: decrypt(process.env.REACT_APP_AWS_SECRET_ACCESS_KEY),
//   }
// });

const FaceVerify = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  let token = JSON.parse(localStorage.getItem("token"));
  const location = useLocation();
  const age_limit = location?.state?.age_limit ?? 0;
  const keys = location?.state?.keys ?? [];
  const awsSessionId = location?.state?.awsSessionId;
  const initialLanguage = location?.state?.language || "en";
  const [status, setStatus] = useState("");
  const [language, setLanguage] = useState(initialLanguage);
  const [error, setError] = useState(null);

  const REGION = decrypt(process.env.REACT_APP_AWS_PROJECT_REGION);
  const IDENTITY_POOL_ID = keys.identityId;




  const s3 = new S3Client({
    region: "eu-west-1",
    credentials: guestCredentialProvider
  });



 

  const dictionary = {
    en: null, // English default
    es: {
      photosensitivyWarningHeadingText: "Advertencia de fotosensibilidad",
      photosensitivyWarningBodyText:
        "Esta verificación muestra luces de colores. Tenga cuidado si es fotosensible.",
      goodFitCaptionText: "Buen ajuste",
      tooFarCaptionText: "Demasiado lejos",
      hintCenterFaceText: "Centra tu cara",
      startScreenBeginCheckText: "Comenzar a verificar",
      hintTooFarText: "Acércate",
      hintHoldFaceForFreshnessText: "Quédate quieto",
    },
    it: {
      photosensitivyWarningHeadingText: "Avviso di fotosensibilità",
      photosensitivyWarningBodyText:
        "Questa verifica mostra luci colorate. Prestare attenzione se si è fotosensibili.",
      goodFitCaptionText: "Buona inquadratura",
      tooFarCaptionText: "Troppo lontano",
      hintCenterFaceText: "Centra il viso",
      startScreenBeginCheckText: "Inizia la verifica",
      hintTooFarText: "Avvicinarsi",
      hintHoldFaceForFreshnessText: "Stai fermo",
    },
  };


  const getImageBytes = async (bucket, key) => {
    const command = new GetObjectCommand({ Bucket: bucket, Key: key });
    const response = await s3.send(command);

    const reader = response.Body.getReader();
    const chunks = [];
    let done = false;

    while (!done) {
      const { value, done: readerDone } = await reader.read();
      if (value) chunks.push(...value);
      done = readerDone;
    }

    const byteArray = new Uint8Array(chunks);
    return byteArray;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const warningEl = document.querySelector(
        ".amplify-liveness-start-screen-warning"
      );
      if (warningEl) warningEl.remove();

      const cameraEl = document.querySelector(
        ".amplify-liveness-recording-icon-container"
      );
      if (cameraEl) cameraEl.style.display = "none";

      const anchorEl = document.querySelector(".amplify-liveness-video-anchor");
      if (anchorEl) anchorEl.style.aspectRatio = "1.33233 / 1";

      const ovalCanvas = document.querySelector(
        ".amplify-liveness-oval-canvas"
      );
      if (ovalCanvas) {
        ovalCanvas.style.aspectRatio = "3 / 4";
        ovalCanvas.style.objectFit = "cover";
        ovalCanvas.style.display = "flex";
        ovalCanvas.style.alignItems = "center";
        ovalCanvas.style.justifyContent = "center";
      }

      const cameraModule = document.querySelector(
        ".amplify-liveness-camera-module"
      );
      if (cameraModule) cameraModule.style.border = "none";

      const button = document.querySelector(
        ".amplify-button.amplify-field-group__control.amplify-button--primary"
      );
      if (button) {
        button.style.backgroundColor = "#FD0000FF";
        button.style.color = "#ffffff";
        button.style.borderColor = "#FD0000FF";
        button.textContent = "Start Verification";
      }

      const videoContainer = document.querySelector(".amplify-liveness-video");
      if (videoContainer) {
        videoContainer.style.margin = "0";
        videoContainer.style.padding = "0";
        videoContainer.style.height = "100%";
        videoContainer.style.width = "100%";
        videoContainer.style.objectFit = "cover";
      }

      // Clear interval if all elements are found
      if (anchorEl && ovalCanvas && cameraModule && button && videoContainer) {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (awsSessionId) {
      const interval = setInterval(() => {
        const button = document.querySelector(
          ".amplify-button.amplify-field-group__control.amplify-button--primary"
        );
        if (button) {
          button.click();
          clearInterval(interval);
        }
      }, 100);
      return () => clearInterval(interval);
    }
  }, [awsSessionId]);

  useEffect(() => {
    const removeRecordingIcon = () => {
      const traverseShadowRoots = (node) => {
        if (!node) return false;
        if (node.shadowRoot) {
          const target = node.shadowRoot.querySelector(
            ".amplify-liveness-recording-icon-container"
          );
          if (target) {
            target.style.display = "none";
            return true;
          }
          return Array.from(node.shadowRoot.querySelectorAll("*")).some(
            traverseShadowRoots
          );
        }
        return Array.from(node.children).some(traverseShadowRoots);
      };
      traverseShadowRoots(document.body);
    };

    const observer = new MutationObserver(removeRecordingIcon);
    observer.observe(document.body, { childList: true, subtree: true });
    removeRecordingIcon();

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (sessionId) {
      handleTrackPageVisiting();
    }
  }, [sessionId]);

  const handleTrackPageVisiting = useCallback(async () => {
    try {
      const response = await trackPageVisiting(sessionId);
    } catch (error) {
      console.error("Failed to track page visiting:", error);
    }
  }, [sessionId]);

  const handleAnalysisComplete = useCallback(
    async (result) => {
      let status = "error";

      try {
        const rekognition = new RekognitionClient({
        region: REGION,
        credentials: guestCredentialProvider, // same creds
      });
        const command = new GetFaceLivenessSessionResultsCommand({
          SessionId: awsSessionId,
        });

        const result = await rekognition.send(command);
        const isLive = result.Confidence && result.Confidence > 70;


        const bucket = result.ReferenceImage.S3Object.Bucket;
        const key = result.ReferenceImage.S3Object.Name;
        // const imageBytes = await getImageBase64(bucket,key);

        const imageBytes = await getImageBytes(bucket, key);

        // const imageBase64 = await captureImageFromWebcam();
        // const base64ToBytes = (base64) => {
        //   const binary = atob(base64.split(",")[1]);
        //   const buffer = new Uint8Array(binary.length);
        //   for (let i = 0; i < binary.length; i++) {
        //     buffer[i] = binary.charCodeAt(i);
        //   }
        //   return buffer;
        // };

        // const imageBytes = base64ToBytes(imageBase64);
        const detectCommand = new DetectFacesCommand({
          Image: { Bytes: imageBytes },
          Attributes: ["ALL"],
        });

        const detectResult = await rekognition.send(detectCommand);
        const ageRange = detectResult?.FaceDetails?.[0]?.AgeRange;

        if (
          !detectResult.FaceDetails ||
          detectResult.FaceDetails.length === 0 ||
          !ageRange
        ) {
          status = "timeout";
        } else {
          status = ageRange.Low >= age_limit ? "success" : "fail";
        }

        const payload = {
          json: detectResult,
          awsConfidence: result.Confidence,
        };
        const response = await verifyProcess(sessionId, payload);

        if (response?.data?.status === "success") {
          const url = response?.data?.redirect_url;

         const command = new DeleteObjectCommand({
    Bucket: "certage-new2",
    Key: key,
  });

  try {
    await s3.send(command);
  } catch (error) {
  }

          navigate("/verified", {
            state: { language, url },
          });

        } else {
          const url = response?.data?.redirect_url;
          navigate("/error", {
            state: { url },
          });
        }
      } catch (error) {
        console.error("Error in handleAnalysisComplete:", error);
        if (error.name === "NotAuthorizedException") {
          setError(
            new Error(
              "Unauthenticated access is not supported. Please sign in."
            )
          );
        } else if (error.message?.toLowerCase().includes("timeout")) {
          status = "timeout";
        }
        setStatus(status);
      }
    },
    [awsSessionId, age_limit, navigate, sessionId]
  );


  const handleError = useCallback((error) => {
    console.error("Liveness error:", error);
    setError(error);
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => stream.getTracks().forEach((track) => track.stop()))
      .catch((err) => console.error("Error stopping camera:", err));
  }, []);

  const handleTryAgain = useCallback(() => {
    setError(null);
    navigate(`/`);
  }, []);

  const handleUserCancel = useCallback(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => stream.getTracks().forEach((track) => track.stop()))
      .catch((err) => console.error("Error stopping camera:", err));
    navigate(`/?token=${token}`);
  }, [navigate]);

  return (
    <ThemeProvider>
      <div>
        {!awsSessionId ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              flexDirection: "column",
            }}
          >
            <img src={images.spinner} />
            <Typography color="primary.text">
              Waiting for camera authorization...
            </Typography>
          </div>
        ) : (
          <div
            style={{
              height: "98vh",
            }}
          >
            <div className="oval-container">
              <FaceLivenessDetector
                sessionId={awsSessionId}
                region={REGION}
                onAnalysisComplete={handleAnalysisComplete}
                onError={(err) => console.error("Liveness error", err.error)}
                onUserCancel={handleUserCancel}
                onTryAgain={handleTryAgain}
                redirect_url={`${window.location.origin}/?token=${token}`}
                displayText={dictionary[language]}
                mandatorySignIn={true}
                disableDefaultUI={false}
              />
            </div>
          </div>
        )}
        {error && (
          <div style={{ color: "red", textAlign: "center" }}>
            Error: {error.message || "An error occurred"}
          </div>
        )}
      </div>
    </ThemeProvider>
  );
};

export default FaceVerify;
